import styled from '@emotion/styled';
import { rem } from '@utils';

const FeedbackWrapper = styled.div`
  display: flex;
  gap: ${rem(4)};
  padding: ${rem(8)} 0;
`;

const Button = styled.button<{ selected?: boolean }>(
  ({ selected, theme }) => `
  background: ${selected ? theme.palette.primary.dark : 'transparent'};
  border: none;
  border-radius: 4px;
  color: ${theme.palette.common[selected ? 'white' : 'black']};
  cursor: pointer; 
  display: inline-flex;
  padding: ${rem(8)};
  transition: background 150ms ease-in, color 100ms ease, scale 100ms ease;

  &:hover {
    color: ${
      selected ? theme.palette.common.white : theme.palette.primary.main
    };
  }

  &:active {
    scale: 0.85;
  }
`
);

const MoreFeedbackWrapper = styled.div<{ visible: boolean }>(
  ({ visible, theme }) => `
  margin-top: ${visible ? rem(32) : 0};
  height: ${visible ? 'auto' : 0};
  opacity: ${visible ? 1 : 0};
  overflow: hidden;
  transition: opacity 400ms ease-in-out, height 0ms;

  &:last-of-type {
    margin-bottom: ${visible ? rem(16) : 0};
  }

  // Small fix
  && .feedback-input {
    font-weight: 500;
    line-height: ${rem(20)};
    padding-top: 4px;
  }

  @media (max-width: 768px) {
    && .feedback-input::placeholder {
      font-size: ${rem(16)};
      line-height: inherit;
    }
  }

  .selected {
    background: ${theme.palette.primary.dark} !important;
    border-color: ${theme.palette.primary.dark} !important;
    color: ${theme.palette.common.white} !important;
  }

  @media (max-width: 768px) {
    && .feedback-input {
      font-size: ${rem(16)};
    }
  }
`
);

const Label = styled.p`
  color: ${({ theme }) => theme.palette.common.black};
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  margin: ${rem(8)} 0;
`;

const Reasons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(8)};
  width: 100%;

  // Do not show any style change on mobile devices
  @media (hover: hover) and (pointer: coarse) {
    && .feedback-reason:hover {
      border-color: ${({ theme }) => theme.palette.grey['500']};
      color: inherit;
    }
  }
`;

const AdditionalFeedbackWrapper = styled.div`
  margin-top: ${rem(24)};
  margin-bottom: ${rem(8)};
`;

const SmallLabel = styled.label`
  color: ${({ theme }) => theme.palette.grey['600']};
  display: block;
  font-size: ${rem(12)};
  line-height: ${rem(14)};
  margin-bottom: ${rem(4)};

  @media (max-width: 430px) {
    font-size: ${rem(14)};
    line-height: ${rem(20)};
  }
`;

const DialogFooter = styled.div`
  display: flex;
  gap: ${rem(8)};
  justify-content: flex-end;
  width: 100%;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  border-radius: 4px;
  color: inherit;
  cursor: pointer;
  display: flex;
  padding: 0;
  transition: 100ms ease;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  &:active {
    background: ${({ theme }) => theme.palette.primary.dark};
    color: ${({ theme }) => theme.palette.common.white};
  }
`;

export default {
  AdditionalFeedbackWrapper,
  Button,
  CloseButton,
  DialogFooter,
  FeedbackWrapper,
  Label,
  MoreFeedbackWrapper,
  Reasons,
  SmallLabel
};
